import React from 'react';
import notFoundImg from '../../images/page-not-found.PNG';

export const ServerErrorComponent = () => {
  const location = window.location.hostname;
  let showVPNError = false;
  if (
    location.includes('local.dev.insights.mrisimmons') ||
    location.includes('localhost') ||
    location.includes('integration')
  ) {
    showVPNError = true;
  }
  return (<div className="row no-match-container">
    <div className="large-4 medium-4 columns icon-content">
      <img style={{ height: '250px' }} src={notFoundImg} alt="page" />
    </div>
    <div className="large-8 medium-8 columns text-content">
      <div className="first-line">Ooops... Network Error</div>
      <div className="second-line">We are sorry, please contact Simmons administrator.</div>
      {showVPNError && <div className="third-line">
        <span>Please check your VPN connection and try again.</span>
      </div>}
    </div>
  </div>);
};
